import React, { useEffect, useRef, useState } from 'react';

import { useSelector } from 'react-redux';
import { RootState } from '../../../store';

import { FontIcon, HoverCard, IBasePicker, IBasePickerSuggestionsProps, IExpandingCardProps, Text, IPersonaProps, IPickerItemProps, ITag, ITextStyles, ITooltipHostStyles, Label, mergeStyleSets, NormalPeoplePicker, PeoplePickerItem, Persona, PersonaSize, ValidationState, IconButton, Callout, DelayedRender, TooltipHost, TooltipOverflowMode, IHoverCardStyles, Shimmer, ShimmerElementsGroup, ShimmerElementType, mergeStyles, DirectionalHint, ExpandingCardMode, IExpandingCard, IExpandingCardStyles, IExpandingCardStyleProps } from '@fluentui/react';

import { IField, IAutocompleteField, IContact } from '../../../shared/interfaces';
import { Indici_FormMode, Search_QueryOperator } from '../../../shared/enums';
import AppUtilities from '../../../shared/Utilities/appUtilities';
import contactsService from '../../../services/contacts.service';
import { useBoolean } from '@fluentui/react-hooks';
import ReadonlyField from '../ReadonlyField';
import axios, { CancelTokenSource } from 'axios';
import { toastRef } from '../../Layout/Layout';
import { IBaseCardProps } from '@fluentui/react/lib/components/HoverCard/BaseCard.types';


const classNames = mergeStyleSets({
    inputWrapper:
    {
        paddingBottom: '20px',

    },
    compactCard: {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        padding: "0 20px"
    },
    expandedCard: {
        padding: '16px 24px 24px'
    },
    iconClass: {
        fontSize: 20,
        margin: '0 25px'
    },
    callout: {
        padding: '8px',
    },
    contactInfoGroup: {
        padding: '4px 0px',
    },

    address: {
        height: '20px'
    }
});


let cancelTokenSources = {};

export interface AutocompleteContactProps {
    formMode?: Indici_FormMode
    field: IField
    autofocus?: boolean,
    changed: (newField: IField) => void
}

const AutocompleteContact: React.FunctionComponent<AutocompleteContactProps> = props => {


    const selectCurrentAoo = (state: RootState) => state.sessionReducer.currentAoo;
    const currentAoo = useSelector(selectCurrentAoo);

    const [contactCard, setContactCard] = useState<any>();
    const [mostRecentlyContactsUsed, setMostRecentlyContactsUsed] = useState<any[]>([]);
    const [shimmerElementsVisible, { setTrue: showShimmerElements, setFalse: hideShimmerElements }] = useBoolean(false);

    useEffect(() => {
        // Anything in here is fired on component mount.


        return () => {
            // Anything in here is fired on component unmount.

            // cancello tutte le request in pending
            for (const [key, value] of Object.entries<CancelTokenSource>(cancelTokenSources)) {
                value.cancel(`${key} canceled`)
            }

        }
    }, [])


    const peoplePickerRef = React.createRef<IBasePicker<IPersonaProps>>();
    useEffect(() => {
        if (props.autofocus)
            peoplePickerRef.current?.focusInput();
    }, [peoplePickerRef]);



    const contactsSuggestionProps: IBasePickerSuggestionsProps = {
        suggestionsHeaderText: 'Suggerimenti',
        mostRecentlyUsedHeaderText: 'Contatti suggeriti',
        noResultsFoundText: 'Nessun risultato trovato',
        loadingText: 'Caricamento',
        showRemoveButtons: false,
        forceResolveText: "Cerca valore inserito",
        showForceResolve: props.formMode === Indici_FormMode.Search ? () => { return true } : () => { return false }
    };


    const inputChanged = (newField: IField) => {
        props.changed({ ...newField, valid: AppUtilities.checkFieldValidity(newField), touched: true })
    }


    let contactsField = props.field as IAutocompleteField;

    let selectedContacts: any[] = [];
    if (contactsField.internalValue)
        selectedContacts = [...contactsField.internalValue];


    const createGenericContactPickerItem = (input: string) => {
        let tag = { key: input, text: input, secondaryText: "GenericItem" }
        return tag;
    }


    const onContactsPickerFilterChanged = async (filterText: string, currentContacts?: IPersonaProps[]): Promise<IPersonaProps[]> => {
        if (currentAoo && filterText) {
            let filteredContacts = await filterContactsByText(currentAoo.id, filterText);

            if (currentContacts)
                filteredContacts = removeContactsPickerDuplicates(filteredContacts, currentContacts);

            return filteredContacts;
        } else {
            return [];
        }
    };
    const filterContactsByText = async (aooId: number, filterText: string): Promise<IPersonaProps[]> => {
        let contacts: any[] = [];
        await contactsService.getContactSuggestions(aooId, contactsField.list, filterText.toLowerCase())
            .then(suggestions => {
                suggestions.forEach(contact => {
                    let secondaryText = contact.email1 ?? contact.email2 ?? "";
                    contacts.push(
                        {
                            key: contact.id,
                            imageInitials: contact.iniziali,
                            text: contact.contatto,
                            secondaryText: secondaryText,
                            showSecondaryText: true,
                            hidePersonaDetails: false,
                            contact
                        }
                    );
                })
            });
        return contacts;
    };
    const removeContactsPickerDuplicates = (contacts: IPersonaProps[], possibleDupes: IPersonaProps[]) => {
        return contacts.filter(contact => possibleDupes.findIndex(el => el.key === contact.key) < 0);
    }


    const returnMostRecentlyContactsUsed = (currentContacts?: IPersonaProps[]) => {
        if (currentContacts)
            return removeContactsPickerDuplicates(mostRecentlyContactsUsed, currentContacts);
        else
            return mostRecentlyContactsUsed
    };


    const onContactSelected = (selectedItem: any): IPersonaProps | null => {
        let recent = [...mostRecentlyContactsUsed];
        recent.push({ selectedItem });
        //assegno l'operatore contains solo alle ricerche fatte aggiungendo un item custom 
        // e l'operatore equals alle ricerche fatte attraverso i suggerimenti
        let { search_QueryOperator } = contactsField;

        if (selectedItem.secondaryText === "GenericItem") {
            search_QueryOperator = Search_QueryOperator.Contains;
        } else {
            search_QueryOperator = Search_QueryOperator.Equals;
        }
        props.field.search_QueryOperator = search_QueryOperator;
        // restituendo null il component non aggiunge nessun elemento alla selezione e riesco a controllare
        // gli elementi selezionati tramite inputChanged(selectedItem) che setta l'internalValue del campo
        return selectedItem;
    }


    const onContactChange = (items?: any[]): void => {
        inputChanged({ ...contactsField, internalValue: items });
    };


    const onRenderSuggestionsItem = (persProps: any, itemProps): JSX.Element => {

        const expandingCardProps: IExpandingCardProps = {
            onRenderCompactCard: onRenderCompactCard,
            onRenderExpandedCard: onRenderExpandedCard,
            compactCardHeight: 120,
            directionalHint: DirectionalHint.rightTopEdge,
            directionalHintFixed: false,
            gapSpace: 16,
            calloutProps: {
                isBeakVisible: false,
                calloutWidth: 450

            },

            renderData: persProps,

        };

        return (
            <div key={`Suggestion${persProps.key}`} style={{ padding: 5 }}>
                <HoverCard expandingCardProps={expandingCardProps} >
                    <Persona
                        {...persProps}
                        size={PersonaSize.size32}
                        hidePersonaDetails={false}
                    />
                </HoverCard>
            </div >
        );
    };



    const onRenderItem = (props: IPickerItemProps<any>) => {

        const persProps = {
            ...props,
            item: {
                ...props.item,
                ValidationState: ValidationState.valid,
                showSecondaryText: false,
            },
        };

        const expandingCardProps: IExpandingCardProps = {
            onRenderCompactCard: onRenderCompactCard,
            onRenderExpandedCard: onRenderExpandedCard,
            compactCardHeight: 120,
            directionalHint: DirectionalHint.rightTopEdge,
            directionalHintFixed: false,
            gapSpace: 16,
            calloutProps: {
                isBeakVisible: false,
                calloutWidth: 450

            },

            renderData: props.item,

        };
        return (
            <div key={`Item${persProps.key}`} style={{ padding: 5 }}>
                <HoverCard expandingCardProps={expandingCardProps} onCardHide={onCardHide} >
                    <PeoplePickerItem {...persProps} />
                </HoverCard>
            </div >
        );

    };
    const onCardHide = (): void => {
        setContactCard(undefined);
    };

    const onRenderCompactCard = (persProps): JSX.Element => {
        return (
            <div key={`CompactCard${persProps.key}`} className={classNames.compactCard}>
                <Persona
                    {...persProps}
                    size={PersonaSize.size56}
                    hidePersonaDetails={false}
                />
            </div>
        );
    };
    const onRenderExpandedCard = (persProps): JSX.Element => {

        getContactInfo(persProps);
        let showContact: boolean = arePropertiesPopulated(contactCard, ['contatto', 'nome', 'cognome', 'iniziali', 'stato', 'provincia', 'localita', 'indirizzo', 'cap', 'telefono1', 'telefono2', 'email1', 'email2']);
        let showAddress: boolean = arePropertiesPopulated(contactCard, ['stato', 'provincia', 'localita', 'indirizzo', 'cap']);
        let provincia: string = !!contactCard?.provincia && contactCard?.provincia !== contactCard?.localita ? contactCard?.provincia : "";
        let localitaInfo: string[] = [contactCard?.localita, provincia, contactCard?.cap];
        let localita: string = localitaInfo.filter(el => el).join(" - "); //prende le informazioni sulla località da contactCard, le filtra per rimuovere eventuali valori nulli o undefined e quindi le unisce in una singola stringa separata da " - ".
        return (
            <div key={`ExpandedCard${persProps.key}`}>
                <Shimmer customElementsGroup={getShimmerElements()} isDataLoaded={!shimmerElementsVisible || contactCard}>
                    <div className={classNames.expandedCard}>
                        {showContact &&
                            <Label>Contatto</Label>
                        }

                        {contactCard?.email1 &&
                            <div className={`flex flex-row align-items-center ${classNames.contactInfoGroup}`}>
                                <FontIcon aria-label="Mail" iconName="Mail" className={classNames.iconClass} />
                                <ReadonlyField fieldInternalName="email1" content={contactCard.email1} showCopyButton={true}></ReadonlyField>
                            </div>}

                        {contactCard?.email2 &&
                            <div className={`flex flex-row align-items-center ${classNames.contactInfoGroup}`}>
                                <FontIcon aria-label="Mail" iconName="Mail" className={classNames.iconClass} />
                                <ReadonlyField fieldInternalName="email2" content={contactCard.email2} showCopyButton={true}></ReadonlyField>
                            </div>}

                        {contactCard?.telefono1 &&
                            <div className={`flex flex-row align-items-center ${classNames.contactInfoGroup}`}>
                                <FontIcon aria-label="Phone" iconName="Phone" className={classNames.iconClass} />
                                <ReadonlyField fieldInternalName="telefono1" content={contactCard.telefono1} showCopyButton={true}></ReadonlyField>
                            </div>}

                        {contactCard?.telefono2 &&
                            <div className={`flex flex-row align-items-center ${classNames.contactInfoGroup}`}>
                                <FontIcon aria-label="Phone" iconName="Phone" className={classNames.iconClass} />
                                <ReadonlyField fieldInternalName="telefono2" content={contactCard.telefono2} showCopyButton={true}></ReadonlyField>
                            </div>}

                        {showAddress &&
                            <div className={`flex flex-row align-items-start ${classNames.contactInfoGroup}`}>
                                <FontIcon aria-label="POI" iconName="POI" className={classNames.iconClass} style={{ paddingTop: "5px" }} />
                                <div className="flex flex-column align-items-start">
                                    <ReadonlyField fieldInternalName="indirizzo" content={contactCard!.indirizzo} showCopyButton={true} className={classNames.address}></ReadonlyField>
                                    <ReadonlyField fieldInternalName="localita" content={localita} showCopyButton={true} className={classNames.address}></ReadonlyField>
                                    <ReadonlyField fieldInternalName="stato" content={contactCard!.stato} showCopyButton={true} className={classNames.address}></ReadonlyField>
                                </div>
                            </div>}
                    </div>
                </Shimmer>
            </div>

        );
    }

    const getContactInfo = (persProps) => {

        if (persProps.contact) {
            setContactCard(persProps.contact);
            hideShimmerElements();
        }
        else if (!contactCard || (contactCard && contactCard.id.toString() !== persProps.key)) {
            // se in cancelTokenSources c'è il cancelToken associato alla chiamata
            // chiamo il metodo cancel che interrompe la chiamata in pending
            if (!cancelTokenSources[contactsService.getContactInfo.name]) {
                cancelTokenSources[contactsService.getContactInfo.name] = axios.CancelToken.source();

                showShimmerElements();
                contactsService.getContactInfo(currentAoo!.id, contactsField.list, persProps.key, cancelTokenSources[contactsService.getContactInfo.name].token)
                    .then(_contact => {
                        setContactCard(_contact);
                        hideShimmerElements();
                        delete cancelTokenSources[contactsService.getContactInfo.name];


                    })
                    .catch(error => {
                        let errorContact = {
                            id: persProps.key
                        }
                        setContactCard(errorContact);
                        hideShimmerElements();
                        delete cancelTokenSources[contactsService.getContactInfo.name];

                        if (axios.isCancel(error)) {
                            //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                            console.log(error.message);
                        } else if (!error.isErrorShown) {
                            toastRef.current?.show({ severity: 'error', summary: 'Attezione', detail: `Impossibile leggere le informazioni del contatto`, life: 5000 });

                        }

                    });

            }
        }
    }
    const getShimmerElements = (): JSX.Element => {
        return (
            <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%' }}>

                <ShimmerElementsGroup
                    flexWrap
                    width={'100%'}
                    shimmerElements={[


                        { type: ShimmerElementType.gap, width: '10%', height: 10 },
                        { type: ShimmerElementType.line, width: '35%', height: 10, verticalAlign: 'bottom' },
                        { type: ShimmerElementType.gap, width: '55%', height: 10 },



                        { type: ShimmerElementType.gap, width: '10%', height: 20 },
                        { type: ShimmerElementType.line, width: '55%', height: 10, verticalAlign: 'bottom' },
                        { type: ShimmerElementType.gap, width: '35%', height: 20 },

                        { type: ShimmerElementType.gap, width: '10%', height: 20 },
                        { type: ShimmerElementType.line, width: '80%', height: 10, verticalAlign: 'bottom' },
                        { type: ShimmerElementType.gap, width: '10%', height: 20 },


                        { type: ShimmerElementType.gap, width: '100%', height: 0.5 },


                        { type: ShimmerElementType.gap, width: '10%', height: 20 },
                        { type: ShimmerElementType.line, width: '55%', height: 10, verticalAlign: 'bottom' },
                        { type: ShimmerElementType.gap, width: '35%', height: 20 },

                        { type: ShimmerElementType.gap, width: '10%', height: 20 },
                        { type: ShimmerElementType.line, width: '80%', height: 10, verticalAlign: 'bottom' },
                        { type: ShimmerElementType.gap, width: '10%', height: 20 },


                        { type: ShimmerElementType.gap, width: '100%', height: 0.5 },


                        { type: ShimmerElementType.gap, width: '10%', height: 20 },
                        { type: ShimmerElementType.line, width: '55%', height: 10, verticalAlign: 'bottom' },
                        { type: ShimmerElementType.gap, width: '35%', height: 20 },

                        { type: ShimmerElementType.gap, width: '10%', height: 20 },
                        { type: ShimmerElementType.line, width: '80%', height: 10, verticalAlign: 'bottom' },
                        { type: ShimmerElementType.gap, width: '10%', height: 20 },

                        { type: ShimmerElementType.gap, width: '100%', height: 0.5 },

                    ]}
                />

            </div>


        );
    };
    return (
        <div className={classNames.inputWrapper}>
            <div className={contactsField.touched && !contactsField.valid ? 'field error' : 'field'}>
                <Label className='field-label' htmlFor={contactsField.internalName} required={contactsField.required}>{contactsField.displayName}</Label>
                <NormalPeoplePicker
                    key={contactsField.internalName}
                    className={'ms-PeoplePicker'}
                    pickerSuggestionsProps={contactsSuggestionProps}
                    getTextFromItem={getTextFromPersonaItem}
                    createGenericItem={createGenericContactPickerItem}
                    selectionAriaLabel={'Selected contacts'}
                    removeButtonAriaLabel={'Remove'}
                    // inputProps={{
                    //     onBlur: (ev: React.FocusEvent<HTMLInputElement>) => console.log('onBlur called'),
                    //     onFocus: (ev: React.FocusEvent<HTMLInputElement>) => console.log('onFocus called'),
                    //     'aria-label': 'People Picker',
                    // }}
                    resolveDelay={300}
                    disabled={contactsField.readonly || contactsField.disabled}
                    selectedItems={selectedContacts}
                    itemLimit={contactsField.multi && props.formMode !== Indici_FormMode.Search ? undefined : 1}
                    componentRef={peoplePickerRef}

                    // eslint-disable-next-line react/jsx-no-bind
                    onResolveSuggestions={onContactsPickerFilterChanged}
                    // eslint-disable-next-line react/jsx-no-bind
                    // onEmptyInputFocus={returnMostRecentlyUsed}
                    onInputChange={onPeoplePickerInputChange}
                    onValidateInput={validatePersonaInput}
                    onItemSelected={onContactSelected}
                    onChange={onContactChange}

                    onRenderSuggestionsItem={onRenderSuggestionsItem}
                    onRenderItem={onRenderItem}
                />
                {contactsField.touched && !contactsField.valid && <span className="error-message">Campo obbligatorio</span>}

            </div>
        </div>
    );


};


export default AutocompleteContact;






/**
 * Takes in the picker input and modifies it in whichever way
 * the caller wants, i.e. parsing entries copied from Outlook (sample
 * input: "Aaron Reid <aaron>").
 *
 * @param input The text entered into the picker.
 */
function onPeoplePickerInputChange(input: string): string {
    const outlookRegEx = /<.*>/g;
    const emailAddress = outlookRegEx.exec(input);

    if (emailAddress && emailAddress[0]) {
        return emailAddress[0].substring(1, emailAddress[0].length - 1);
    }

    return input;
}

function getTextFromPersonaItem(persona: any): string {
    return persona.contatto as string;
}


function validatePersonaInput(input: string): ValidationState {
    if (input.indexOf('@') !== -1) {
        return ValidationState.valid;
    } else if (input.length > 1) {
        return ValidationState.warning;
    } else {
        return ValidationState.invalid;
    }
}


function atLeastOnePropertyPopulated(contact: IContact): boolean {
    // Get keys of IContact object excluding 'id'
    const keys = Object.keys(contact).filter(key => key !== 'id');

    // Check if at least one of the properties has a value other than an empty string
    return keys.some(key => contact[key as keyof IContact].toString().trim() !== '');
}


function arePropertiesPopulated(contact: IContact, propertyNames: Array<keyof IContact>): boolean {
    if (!contact) {
        return false;
    }
    // Controlla se almeno una delle proprietà specificate ha un valore diverso da una stringa vuota
    return propertyNames.some(propertyName => contact[propertyName] && contact[propertyName].toString().trim() !== '');
}